// 관리자 게시 실시간 수신(SSE). 게시 → 엣지 AdminHub 가 푸시 → 해당 데이터만 갱신.
// 운영은 동일 출처(상대경로), dev는 EDGE_BASE(:8787). 단일 연결을 핸들러들이 공유.
// 엣지/푸시 미가용이어도 무해(폴백: 새로고침·정적 파일). EventSource 자동 재연결.
import { EDGE_BASE } from "./apiBase";

/**
 * 알림 모양은 **shared 단일 정의**를 쓴다(`packages/shared/src/contentUpdate.ts`).
 * 예전엔 여기에 종류를 손으로 적어 뒀는데 엣지와 어긋나도 아무 에러가 안 났다 —
 * `overlayfit` 이 빠져 있어서 관리자에서 맞춘 자리가 화면에 안 나왔다.
 */
export type { ContentUpdate } from "@greg-chick/shared";
import type { ContentUpdate } from "@greg-chick/shared";

type Handler = (u: ContentUpdate) => void;

let es: EventSource | null = null;
let errorStreak = 0;
let disabled = false; // 엣지 미가용(M1 DO 미바인딩 등) — 무한 재연결 폭주 차단
const handlers = new Set<Handler>();
const MAX_ERROR_STREAK = 5;

function ensureConnection(): void {
  if (es || disabled || typeof EventSource === "undefined") return;
  try {
    es = new EventSource(`${EDGE_BASE}/api/admin-events`);
    es.addEventListener("open", () => {
      errorStreak = 0; // 연결 성공 → 카운터 리셋
    });
    es.addEventListener("update", (ev) => {
      try {
        const u = JSON.parse((ev as MessageEvent).data) as ContentUpdate;
        handlers.forEach((h) => h(u));
      } catch {
        /* 잘못된 프레임 무시 */
      }
    });
    es.onerror = () => {
      // EventSource는 자동 재연결(retry:3000). 연속 실패가 누적되면 단념(푸시는 베스트에포트).
      if (++errorStreak >= MAX_ERROR_STREAK) {
        es?.close();
        es = null;
        disabled = true;
      }
    };
  } catch {
    es = null;
  }
}

/** 게시 업데이트 구독. 반환값 호출로 해지(마지막 구독 해지 시 연결 종료). */
export function subscribeContentUpdates(handler: Handler): () => void {
  handlers.add(handler);
  ensureConnection();
  return () => {
    handlers.delete(handler);
    if (handlers.size === 0 && es) {
      es.close();
      es = null;
    }
  };
}
